import React from 'react';
import '../Style/Logistics.css'; // ✅ Ensure this file exists in your project

const Logistics = () => {
  return (
    <div className="logistics-container">
      <div className="logistics-text">
        <h2>Supply Chain & Logistics</h2>
        <p className='logistics-description'>
            Managing your supply chain efficiently is crucial to keeping your projects on track. At Automotive Devices, we offer comprehensive supply chain and logistics services to simplify your production process from start to finish. Our experienced team handles everything from material procurement to inventory management, ensuring that your components arrive on time and meet your exact specifications.<br></br> With a global network of trusted suppliers and strong domestic and international partnerships, we provide cost-effective solutions while maintaining the highest quality standards.

We take the hassle out of managing multiple vendors by offering turnkey solutions that allow you to focus on your core business. Whether it's sourcing hard-to-find components or coordinating complex production schedules, Automotive Devices acts as your single point of contact to keep your supply chain running smoothly. You can rely on us to manage lead times, logistics, and quality control, ensuring that your production stays on schedule and within budget.
        </p>
      </div>
      <div className="logistics-image">
        <img src="/supplychain.jpeg" alt="Logistics" />
      </div>
    </div>
  );
};

export default Logistics;
